import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { FBXLoader } from 'three/addons/loaders/FBXLoader.js';

export interface LoadedMesh {
  object: THREE.Object3D;
  bones: THREE.Bone[];
}

const gltfLoader = new GLTFLoader();
const fbxLoader = new FBXLoader();

/**
 * Load an optional character mesh used as a retarget puppet. Supports binary glTF
 * (.glb), .gltf and .fbx. The mesh is normalized to ~human scale and grounded.
 */
export async function parseTargetMesh(buffer: ArrayBuffer, ext: string): Promise<LoadedMesh> {
  let object: THREE.Object3D;

  if (ext === 'glb' || ext === 'gltf') {
    const gltf = await gltfLoader.parseAsync(buffer, '');
    object = gltf.scene;
  } else {
    object = fbxLoader.parse(buffer, '');
  }

  const bones: THREE.Bone[] = [];
  object.traverse((child) => {
    if ((child as THREE.Bone).isBone) bones.push(child as THREE.Bone);
  });

  normalize(object);
  return { object, bones };
}

function normalize(object: THREE.Object3D): void {
  object.updateWorldMatrix(true, true);
  const box = new THREE.Box3().setFromObject(object);
  if (box.isEmpty()) return;

  const size = new THREE.Vector3();
  box.getSize(size);
  if (size.y > 10) object.scale.multiplyScalar(0.01);

  object.updateWorldMatrix(true, true);
  const grounded = new THREE.Box3().setFromObject(object);
  object.position.y -= grounded.min.y;
  object.updateWorldMatrix(true, true);
}
